<script>
    export let width = 48;
    export let height = 48;
    export let color = "#fff";
</script>

<svg
{width} {height}  viewBox="0 0 512 512"
>
    <g>
        <path
            d="M384 400.33l35.13-.33A29 29 0 00448 371.13V140.87A29 29 0 00419.13 112l-35.13.33M128 112l-36.8.33c-15.88 0-27.2 13-27.2 28.87v230.27c0 15.87 11.32 28.86 27.2 28.86L128 400M384 192v128M320 160v192M256 176v160M192 160v192M128 192v128"
            fill="none"
            stroke={color}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="28"
        />
    </g>
</svg>
